module.exports = __webpack_public_path__ + "img/paper-tickets.9ee5efbd.svg";